import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isObject, isMergeable } from './is';
import { insertPoint } from './flat';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var PATH_MODE = {
  loose: '?',
  strict: '!',
  insert: '^',
  append: '$'
};
export function filterProps(obj) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!isObject(obj)) return obj;

  if (typeof props === 'function') {
    var prediction = props;
    props = [];
    Object.keys(obj).forEach(function (k) {
      if (prediction(obj[k])) props.push(k);
    });
  }

  var newObj = {};
  props.forEach(function (k) {
    newObj[k] = obj[k];
  });
  return newObj;
} // Object.values()

export var objectValues = function objectValues(obj) {
  if (!obj) return [];
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
}; // object only, not handle array.

export var deepMerge = function deepMerge() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 ? arguments[1] : undefined;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var clone = options.clone,
      removeUndefined = options.removeUndefined,
      skipUndefined = options.skipUndefined;
  if (!isMergeable(source)) return source;
  var dest = {};

  if (isMergeable(target)) {
    Object.keys(target).forEach(function (k) {
      dest[k] = clone ? deepMerge({}, target[k], options) : target[k];
      if (removeUndefined && dest[k] === undefined) delete dest[k];
    });
  }

  Object.keys(source).forEach(function (k) {
    if (isMergeable(source[k]) && isMergeable(target[k])) {
      dest[k] = deepMerge(target[k], source[k], options);
    } else {
      if (skipUndefined && source[k] === undefined) return;
      dest[k] = deepMerge({}, source[k], options);
      if (removeUndefined && dest[k] === undefined) delete dest[k];
    }
  });
  return dest;
};
export function pathGenerator(raw) {
  var path = insertPoint(raw);
  var reg = /^\[(\d+)\]$/;
  var pathModeValues = objectValues(PATH_MODE);
  var index = 0;
  var last = 0;
  var prop = '';
  var results = [];

  while (index >= 0) {
    index = path.indexOf('.', last);
    prop = path.substring(last, index === -1 ? undefined : index);
    var mode = void 0;
    var lastChar = prop.charAt(prop.length - 1);

    if (pathModeValues.includes(lastChar)) {
      mode = lastChar;
      prop = prop.substring(0, prop.length - 1);
    } // array index


    var match = reg.exec(prop); // eslint-disable-next-line

    if (match) prop = parseInt(match[1], 10);
    last = index + 1;
    results.push([prop, index === -1 ? undefined : path.substring(last), mode]);
  }

  return results;
}
export var deepSet = function deepSet(target, path, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!isObject(target)) throw new Error('Target must be an object.');
  if (typeof path !== 'string') throw new Error('Path must be a string.');
  var removeUndefined = options.removeUndefined,
      skipUndefined = options.skipUndefined;
  var mergeOptions = {
    clone: true,
    removeUndefined: removeUndefined,
    skipUndefined: skipUndefined // empty root

  };

  if (path === '') {
    var dest = deepMerge(target, value, mergeOptions);
    Object.keys(dest).forEach(function (k) {
      ;
      target[k] = dest[k];
    });
    return target;
  }

  var current = target;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = pathGenerator(path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 3),
          prop = _step$value[0],
          next = _step$value[1],
          mode = _step$value[2];

      if (next) {
        var nextIsArray = /^\[\d+\]/.test(next);
        if (!current[prop]) current[prop] = nextIsArray ? [] : {};

        if (nextIsArray && !Array.isArray(current[prop])) {
          throw new Error("Path ".concat(path, " expect an array."));
        } else if (Array.isArray(current[prop]) && !nextIsArray) {
          throw new Error("Path ".concat(path, " is an array, expect an object."));
        }

        current = current[prop];
        continue;
      }

      if (options.forceSet) {
        current[prop] = value;
      } else if (mode === PATH_MODE.insert) {
        current.splice(prop, 0, value);
      } else if (mode === PATH_MODE.append) {
        current.splice(prop + 1, 0, value);
      } else {
        if (skipUndefined && value === undefined) break;
        current[prop] = isMergeable(current[prop]) && isMergeable(value) ? deepMerge(current[prop], value, mergeOptions) : value;
      }

      if (removeUndefined && value === undefined) delete current[prop];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return target;
};
export var deepGet = function deepGet(target, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!isObject(target)) throw new Error('Target must be an object.');
  if (typeof path !== 'string') throw new Error('Path must be a string.'); // empty root

  if (path === '') return target;
  var defaultValue = options.defaultValue,
      strictMode = options.strictMode;
  var current = target;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = pathGenerator(path)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _step2$value = _slicedToArray(_step2.value, 3),
          prop = _step2$value[0],
          mode = _step2$value[2];

      var isStrict = mode === PATH_MODE.strict || strictMode && defaultValue === undefined && mode !== PATH_MODE.loose;

      if (current != null && hasOwnProperty.call(current, prop)) {
        current = current[prop];
      } else if (isStrict) {
        throw new Error("Path ".concat(path, " is not exist."));
      } else {
        current = defaultValue;
        break;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
        _iterator2["return"]();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return current;
};
export var deepRemove = function deepRemove(target, path) {
  if (!isObject(target)) throw new Error('Target must be an object.');
  if (typeof path !== 'string' || !path) throw new Error('Path must be a string.');
  var current = target;
  var nextIsArray = false;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = pathGenerator(path)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          prop = _step3$value[0],
          next = _step3$value[1];

      if (current == null || !hasOwnProperty.call(current, prop)) {
        break;
      }

      if (next) {
        current = current[prop];
        nextIsArray = /^\[\d+\]/.test(next);
      } else if (isObject(current)) {
        if (nextIsArray) throw new Error('Target is an object, expect array');
        delete current[prop];
      } else {
        if (!nextIsArray) {
          throw new Error('Target is an array, expect object');
        }

        ;
        current.splice(prop, 1);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
        _iterator3["return"]();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return target;
};
export var deepHas = function deepHas(target, path) {
  if (!isObject(target)) throw new Error('Target must be an object.');
  if (typeof path !== 'string') throw new Error('Path must be a string.');
  if (path === '') return true;
  var current = target;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = pathGenerator(path)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _step4$value = _slicedToArray(_step4.value, 2),
          prop = _step4$value[0];

      if (!current || !hasOwnProperty.call(current, prop)) return false;
      current = current[prop];
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
        _iterator4["return"]();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return true;
};
export var entries = function entries(obj) {
  if (!obj) return [];
  var keys = Object.keys(obj);
  return keys.map(function (key) {
    return [key, obj[key]];
  });
};